<template>
  <div v-if="loading">
    <v-flex offset-xs5 pa-5>
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
  </div>
  <div v-else>
    <v-container fluid grid-list-md>
      <v-layout>
        <v-flex>
          <v-card>
            <v-layout>
              <v-flex xs2 pt-4 ml-1 mt-2 v-if="$store.getters.isSafRole">
                <v-img :src="consulta.autor.club.logo" max-height="90px" contain></v-img>
                <v-card-text class="text-xs-center">{{ consulta.autor.club.nombre }}</v-card-text>
              </v-flex>
              <v-flex xs12>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">Asunto: {{ consulta.title }}</div>
                    <v-divider class="my-1"></v-divider>
                    <div v-if="consulta.partido.description != ''">
                      <div><b>Torneo: </b> <span>{{ consulta.partido.tournamentName}}</span></div>
                      <div><b>Fecha: </b> <span>{{ consulta.partido.fechaName}}</span></div>
                      <div><b>Partido: </b> <span :class="this.$store.state.permissions.canViewFichaPartidoClub ? `match-description` : ``" @click="goToFichaPartido">{{ consulta.partido.description}}</span></div>
                    </div>
                    <div><b>Departamento:</b> {{ consulta.departamento }}</div>
                    <div><b>Estado:</b> {{ consulta.estado }}</div>
                    <div><b>Fecha de creación:</b> {{ consulta.mensajes[0].created }}</div>
                    <div><b>Última modificación:</b> {{ consulta.modified }}</div>
                    <div><b>Código de consulta:</b> {{ consulta.id }}</div>
                    <div v-if="isDerivada"><b>Consulta derivada desde:</b> {{ consulta.derivadaFrom }}</div>
                  </div>
                  <v-spacer></v-spacer>
                  <div>
                    <div class="center">
                      <v-btn v-if="consulta.canCloseAndDerivar" @click="closeConsulta" color="red lighten-2">Cerrar
                        Consulta</v-btn>
                    </div>
                    <div class="center">
                      <v-btn v-if="consulta.canCloseAndDerivar && $store.getters.isSafRole" @click="goToDerivar"
                        color="primary">
                        Derivar Consulta
                      </v-btn>
                      <DerivarConsulta :consulta="consulta" @hideDerivarDialog="hideEdit" @updateConsulta="updateConsulta"
                        v-if="derivar">
                      </DerivarConsulta>
                    </div>
                    <div class="center">
                      <v-btn v-if="consulta.canAssignMatch && $store.getters.isSafRole" @click="goToAddPartido"
                        color="primary">
                        Asignar partido
                      </v-btn>
                      <AsignarPartidoVue :consulta="consulta" @hideAddPartidoDialog="hideAddPartido"
                        v-if="addPartido">
                      </AsignarPartidoVue>
                    </div>
                    <div class="center">
                      <v-btn color="primary" @click="goToHistory">
                        <v-icon small color="white" class="icon-build">history</v-icon>
                        <span>Historial</span>
                      </v-btn>
                      <ConsultaHistory ref="history" :history="consulta.history" @hideHistoryDialog="hideHistory"
                        v-if="showHistoryDialog">
                      </ConsultaHistory>
                    </div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <br>
      <v-layout row wrap>
        <v-flex v-for="mensaje in consulta.mensajes" :key="mensaje.id" class="layout xs12" style="padding-top:20px">

          <div v-if="differentAuthor(mensaje.autor)" style="margin-right:15px" class="grey--text xs4 flex"
            :class="{ 'text-xs-right': differentAuthor(mensaje.autor) }">
            {{ mensaje.autor.username }} - {{ mensaje.modified }}
            <div>{{ mensaje.autor.firstName }} {{ mensaje.autor.lastName }} - {{ mensaje.departamento }}</div>
          </div>

          <v-card :class="[differentAuthor(mensaje.autor) ? 'xs8 primary lighten-3 flex ' : ' xs8 flex white']">
            <v-card-text class="text-formatted">{{ mensaje.texto }}
              <div v-if="mensaje.assets.length">
                <v-divider></v-divider>
                <p v-for="asset in mensaje.assets" :key="asset.id">
                  <a :href="asset.url" target="_blank">{{ getAttachmentName(asset.name) }}</a>
                </p>
              </div>
            </v-card-text>
          </v-card>

          <div v-if="!differentAuthor(mensaje.autor)" style="margin-left:15px" class="grey--text xs4 flex">
            {{ mensaje.autor.username }} - {{ mensaje.modified }}
            <div>{{ mensaje.autor.firstName }} {{ mensaje.autor.lastName }}</div>
          </div>

        </v-flex>
      </v-layout>
      <br>
      <v-layout>
        <v-flex v-if="showResponseArea">
          <MensajeConsulta v-bind:consultaId="consulta.id" @update="addMessage"></MensajeConsulta>
        </v-flex>
      </v-layout>
      <GoBackButton />
    </v-container>
  </div>
</template>

<script>
import MensajeConsulta from '../components/MensajeConsulta'
import GoBackButton from '../../../common/ui/GoBackButton'
import DerivarConsulta from '../components/DerivarConsulta'
import ConsultaHistory from '../components/ConsultaHistory'
import AsignarPartidoVue from '../components/AsignarPartido'

export default {
  components: {
    ConsultaHistory,
    DerivarConsulta,
    MensajeConsulta,
    GoBackButton,
    AsignarPartidoVue
  },

  data () {
    return {
      loading: false,
      consulta: {},
      previousAuthor: '',
      history: [],
      derivar: false,
      showHistoryDialog: false,
      addPartido: false
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get(`consulta/${this.$route.params.id}`)
        .then(response => {
          this.consulta = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    differentAuthor (currentAuthor) {
      return (this.consulta.autor.username !== currentAuthor.username)
    },
    addMessage (newMessage) {
      this.consulta.mensajes.push(newMessage)
      this.consulta.canReply = true
    },
    closeConsulta () {
      this.axios
        .put(`consulta/close/${this.$route.params.id}`)
        .then(() => (this.$router.push({ name: 'consultas' })))
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    goToDerivar () {
      this.derivar = true
    },
    goToHistory () {
      this.showHistoryDialog = true
    },
    hideEdit () {
      this.derivar = false
    },
    hideHistory () {
      this.showHistoryDialog = false
    },
    updateConsulta () {
      this.hideEdit()
      this.$router.push({ name: 'consultas' })
    },
    getAttachmentName (attachment) {
      return attachment.split('/').slice(-1).pop()
    },
    goToFichaPartido () {
      if (this.$store.state.permissions.canViewFichaPartidoClub) {
        this.$router.push({ name: 'fichaDePartidoDetail', params: { partidoId: this.consulta.partido.id } })
      }
    },
    goToAddPartido () {
      this.addPartido = true
    },
    hideAddPartido () {
      this.addPartido = false
    }
  },

  computed: {
    showResponseArea () {
      if (this.consulta.hasOwnProperty('canReply')) {
        return this.consulta.canReply
      }
      return false
    },
    isOpen () {
      return this.consulta.estado !== 'Cerrada'
    },
    isDerivada () {
      return this.consulta.derivadaFrom !== ''
    }
  },

  created () {
    this.loading = true
    this.fetchData()
  }
}
</script>

<style scoped>
a {
  color: #1787c9;
}

.center {
  text-align: center;
}

.match-description{
  color: #2479e8;
  cursor: pointer;
}
</style>
